import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Section from '../components/Section';
import PulseList from '../components/PulseList';
import MarketTicker from '../components/MarketTicker';
import EmailCaptureForm from '../components/EmailCaptureForm';
import Arrow from '../components/Arrow';
import { useLanguage } from '../context/LanguageContext';
import { fetchPosts } from '../api';

export default function MarketPulse() {
  const { t, lang } = useLanguage();
  const [posts, setPosts] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    let active = true;
    fetchPosts(lang)
      .then((r) => active && setPosts(r.posts))
      .catch((e) => active && setError(e.message));
    return () => { active = false; };
  }, [lang]);

  const latest = posts && posts[0];
  const past = posts ? posts.slice(1) : [];

  return (
    <>
      <Section eyebrow={t('pulse.eyebrow')} title={t('pulse.title')} lead={t('pulse.lead')}>
        {error && <p className="form__msg form__msg--err">{error}</p>}
        {!posts && !error && <p className="loading">Loading…</p>}

        {latest && (
          <div className="featured" style={{ marginBottom: '3rem' }}>
            <div className="pulse-card__meta" style={{ marginBottom: '1.25rem' }}>
              <span className="tag">{t('pulse.latest')}</span>
              <span>
                {new Date(latest.date).toLocaleDateString(undefined, {
                  day: 'numeric', month: 'long', year: 'numeric',
                })}
              </span>
              <span>·</span>
              <span>{latest.readingMinutes} min read</span>
            </div>
            <MarketTicker market={latest.market} />
            <h3
              style={{
                fontFamily: 'var(--font-display)', fontWeight: 600,
                fontSize: 'clamp(1.5rem, 3vw, 2.1rem)', margin: '1.5rem 0 0.6rem',
              }}
            >
              <Link to={`/market-pulse/${latest.slug}`} style={{ color: 'var(--ink)' }}>
                {latest.title}
              </Link>
            </h3>
            <p style={{ maxWidth: '62ch', marginBottom: '1.6rem' }}>{latest.summary}</p>
            <Link to={`/market-pulse/${latest.slug}`} className="btn btn--primary">
              {t('cta.readPulse')} <Arrow className="btn__arrow" />
            </Link>
          </div>
        )}

        {past.length > 0 && (
          <>
            <p className="section__eyebrow">{t('pulse.past')}</p>
            <PulseList posts={past} />
          </>
        )}

        {posts && posts.length === 0 && <p className="muted">{t('pulse.empty')}</p>}
      </Section>

      <Section alt>
        <div className="callout callout--accent">
          <div className="grid grid-2" style={{ alignItems: 'center', position: 'relative' }}>
            <div>
              <h2 style={{ marginBottom: '0.6rem', fontSize: 'clamp(1.5rem, 3vw, 2.1rem)' }}>
                <span className="callout__dot" aria-hidden />{t('news.title')}
              </h2>
              <p>{t('news.lead')}</p>
            </div>
            <EmailCaptureForm mode="newsletter" source="pulse-newsletter" />
          </div>
        </div>
      </Section>
    </>
  );
}
